import { createReducer, on } from '@ngrx/store';
import * as MessagesActions from './messages.actions';
import { IMessage } from '../model/message.model';
import { MessageState } from './messages.state';
import { IConversation } from '../model/conversation.model';
import { IMessageContacts } from '../model/messageContacts.model';

export const initialMessagesState: MessageState = {
  messages: [] as IMessage[],
  conversations: [] as IMessageContacts[],
  selectedDestinationId: null,
  messageContacts: [] as IMessageContacts[]
};
 
export const MessagesReducer = createReducer(
    initialMessagesState,
    
    on( MessagesActions.MessagesActions.getMessagesSuccess, (state , { messages }) => ({ 
      ...state, 
      messages: messages ?? {} as IMessage[],
    })),

    on( MessagesActions.MessagesActions.getConversationsSuccess, (state , { conversations }) => ({ 
      ...state, 
      conversations: conversations
    })),  

    on( MessagesActions.MessagesActions.getMessages, (state , { destinationId }) => ({ 
      ...state, 
      selectedDestinationId: destinationId
    })), 

    on( MessagesActions.MessagesActions.deleteMessageSentSuccess, (state , { message }) => ({ 
      ...state, 
      messages: [...state.messages.filter(x => x.id !== message.id)]
    })),

    on( MessagesActions.MessagesActions.sendMessageSentSuccess, (state , { message }) => ({ 
      ...state, 
      messages: [...state.messages, message]
    })),

    on( MessagesActions.MessagesActions.addReceivedMessage, (state , { message, destinationId }) => { 
      return {
        ...state, 
        messages: [...state.messages, 
          { 
            destinationId: message.destinationId, 
            messageText: message.messageText, 
            userId: message.userId,
            userName: message.userName
          } as IMessage]
      };
    }),

    on( MessagesActions.MessagesActions.setDestinationId, (state , { destinationId }) => ({ 
      ...state, 
      selectedDestinationId: destinationId
    })),

    on( MessagesActions.MessagesActions.addNewConversation, (state , { conversation }) => ({      
        ...state, 
        conversations: [...state.conversations.filter(x => x.id !== conversation.id), conversation]
    })),

    on( MessagesActions.getMessageContactsSuccess, (state , { messageContacts }) => ({ 
      ...state, 
      messageContacts: messageContacts
    })),      

    on( MessagesActions.MessagesActions.clearMessages, (state , _) => ({ 
      ...state, 
      messages: []
    }))    
);
